import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'

import { Switch } from 'antd'

export const StyledSwitch = styled(Switch, {
  shouldForwardProp: (prop) => prop !== 'switchLabels',
})((props) => {
  const {
    checked,
    switchLabels,
    theme: { switchTrueBackgroundColor, switchFontColor },
  } = props

  return `
    width: 60px;
    height: 30px;

    &.ant-switch {
      &::after {
        width: 30px;
        height: 30px;
        object-fit: contain;
        box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.16);
        top: -1px;
        left: ${checked ? `calc(100% + 2px)` : '-1px'};
        text-transform: uppercase;
        font-size: 10px;
        padding: 5px 0;
        font-weight: bold;
        letter-spacing: 0.2px;
        color: ${switchFontColor};
        ${stylesIf(switchLabels, `content: '${switchLabels(checked)}';`)}
      }
      ${stylesIf(checked, `background: ${switchTrueBackgroundColor};`)}
      
    }
  `
})
